import { useMemo } from 'react';

import { useListUserCauseSelections } from 'core/Api';
import { NavLink, useNavigate } from 'react-router-dom';
import { Anchor } from 'ui';

import { WaysToGiveBackLayout } from './WaysToGiveBack.Layout';

const Buy = () => {
  const { data: userCauseSelections, isLoading: isLoadingUserCauseSelections } =
    useListUserCauseSelections();
  const navigate = useNavigate();

  const cta = useMemo(() => {
    if (isLoadingUserCauseSelections) return undefined;
    if (userCauseSelections?.length && userCauseSelections?.length > 0) {
      // changing from /shop/stores/my-stores to /causes because we are deprecating "buy",
      // and this whole page will be deprecated in the future.
      return { label: 'Buy Now', onClick: () => navigate(`/causes`) };
    } else {
      return { label: 'Find a Cause', onClick: () => navigate(`/causes`) };
    }
  }, [isLoadingUserCauseSelections, userCauseSelections?.length, navigate]);

  return (
    <WaysToGiveBackLayout
      overline="Giveback with"
      title="Every Purchase"
      cta={cta}
      tagline="Shop for items, memberships, and tickets from organizations you support."
      copy={
        <>
          Support your causes easily by purchasing fundraising items, memberships, or tickets
          directly from all of{' '}
          <Anchor component={NavLink} to="/causes">
            your favorite causes
          </Anchor>{' '}
          online store.
        </>
      }
      howItWorks={{
        listItems: [
          'Find: View your list in “My Cause”.',
          "Buy: Visit the “Buy” tab for your causes' online stores.",
          'Order History: Check “Wallet” for receipts and history.',
          'Tickets & Memberships: Find purchased tickets and membership cards in “Wallet”.',
        ],
      }}
    />
  );
};

export { Buy };
